// User reducer types
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED';
export const SET_USER = 'SET_USER';
export const LOADING_USER = 'LOADING_USER';
export const MARK_NOTIFICATIONS_READ = 'MARK_NOTIFICATIONS_READ';
// UI reducer types
export const SET_ERRORS = 'SET_ERRORS';
export const LOADING_UI = 'LOADING_UI';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const LOADING_DATA = 'LOADING_DATA';
export const STOP_LOADING_UI = 'STOP_LOADING_UI';
// Data reducer types
export const SET_SOUNDOFF = 'SET_SOUNDOFF';
export const LIKE_SOUNDOFF = 'LIKE_SOUNDOFF';
export const UNLIKE_SOUNDOFF = 'UNLIKE_SOUNDOFF';
export const DELETE_SOUNDOFF = 'DELETE_SOUNDOFF';
export const POST_SOUNDOFF = 'POST_SOUNDOFF';
export const SUBMIT_COMMENT = 'SUBMIT_COMMENT';
export const SET_SOUNDOFFS = 'SET_SOUNDOFFS';
